import React from 'react';
import { Space, Switch, Button, Divider } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';

const CalculatorTableControls = ({ isRSUIncluded, toggleRSU, isAnnual, toggleAnnualMonthly, exportToCSV }) => (
  <Space 
    direction="horizontal" 
    size="large" 
    split={<Divider type="vertical" />} 
    style={{ marginBottom: 16, display: 'flex', alignItems: 'center' }}
  >
    <Space>
      <span>Include RSU:</span>
      <Switch checked={isRSUIncluded} onChange={toggleRSU} />
    </Space>
    
    <Space>
      <span>Show Annual Values:</span>
      <Switch checked={isAnnual} onChange={toggleAnnualMonthly} />
    </Space>
    
    <Button onClick={exportToCSV} icon={<DownloadOutlined />}>
      Export to CSV
    </Button>
  </Space>
);

export default CalculatorTableControls;